module.exports = __webpack_public_path__ + "static/media/HALA MOHAMAD ALI.3603abfc.png";